//var moment = require("moment-timezone");
import axios from "axios";


const settings = function(key, value) {
    axios.post("https://tradeinpool.com:3001/api/update/users/settings", {
            key: key,
            newValue: value
        })
        .then(() => {
            this.$store.state.userData.settings[key] = value
        })
        .catch(() => {

        })
};


export default settings